import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";

/**
 * CartelesDelMundo — los tres carteles del mundo 3D, montados solo donde pueden salir.
 *
 * QUE SON. Las vidas mientras Omega te persigue, el minijuego de la osa y el del Árbol de las
 * Lenguas. Los tres viven colgados del armazón y no de `Mundo.jsx` por la razón de siempre: el
 * juego pasa dentro de la escena 3D, la escena se desmonta, y un cartel que se desmonta con ella
 * no puede contar cómo acabó. Eso no cambia. Lo que cambia es CUÁNDO se montan.
 *
 * POR QUE EXISTE ESTE FICHERO (28 de septiembre de 2026). Estaban importados a pelo en `App.js`,
 * o sea en la PRIMERA CARGA de todo el mundo. Y detrás de ellos entraba media casa:
 *
 *   · `JuegoDelArbol` → `lib/lenguas.mjs` → `lib/mundo.mjs`, el mapa entero del mundo 3D.
 *   · `Minijuego` → `lib/tandas.mjs` → los cinco bancos de preguntas (familias, sintaxis,
 *     irregulares, formas verbales, sociolingüística).
 *
 * O sea que quien entraba a ver la portada se descargaba las preguntas de los minijuegos y el
 * mapa del mundo antes de leer una línea. `scripts/presupuesto.mjs` lo cazó al pasarse de 260 kB:
 * 277,0 kB. Sacándolos de ahí, 254,5 kB. **21,9 kB que no viajaban por nada.**
 *
 * Y NO SE PIERDE NINGÚN EVENTO, que es lo único que había que cuidar. Los tres escuchan un
 * evento de `window` (`alpha:caceria`, `alpha:minijuego`, `alpha:arbol`) y por eso tienen que
 * estar puestos ANTES de que el mundo lo dispare. Se montan al entrar en una ruta del mundo, y
 * el primer evento no puede llegar hasta que la escena 3D esté montada y el alumno haya andado
 * hasta la osa o hasta el árbol: segundos. El `import()` tarda menos que la propia escena.
 *
 * LAS RUTAS SON LAS QUE PINTAN `Mundo`, y están escritas aquí a mano a propósito: si mañana se
 * añade una cuarta puerta al mundo y no se añade aquí, el cartel no sale. Es el precio de no
 * montar tres componentes en todas las pantallas de la Academia, y queda dicho para que quien
 * añada esa puerta sepa dónde mirar.
 */
const RUTAS_DEL_MUNDO = ["/templo", "/explanada", "/clase"];

// Y DESDE EL 1 DE OCTUBRE DE 2026 TAMBIEN SE MONTA EL CONTADOR DE PASOS, en diferido como los
// tres carteles y por las dos razones de este fichero. **Este fichero entra en la primera carga**
// -lo importa `App.js` a pelo, y debe seguir siendo asi para no perder ningun evento-, asi que
// todo lo que cuelgue de el sin `lazy()` viaja a la portada, y del presupuesto de 260 kB quedan
// 5,3 libres. Y llegar tarde no es un problema: el `import()` tarda menos que montar la escena
// 3D, que es lo que tiene que pasar antes de que haya un solo evento que contar. Es el mismo
// argumento que ya esta escrito aqui arriba para los carteles, y vale igual para el contador.
const PasosDelMundo = lazy(() => import("@/components/PasosDelMundo"));
const Caceria = lazy(() => import("@/components/Caceria"));
const Minijuego = lazy(() => import("@/components/Minijuego"));
const JuegoDelArbol = lazy(() => import("@/components/JuegoDelArbol"));

export default function CartelesDelMundo() {
  const { pathname } = useLocation();
  const enElMundo = RUTAS_DEL_MUNDO.some(
    (r) => pathname === r || pathname.startsWith(r + "/")
  );
  if (!enElMundo) return null;
  // `fallback={null}`: estos no pintan nada hasta que su evento llega, así que mientras carga
  // su trozo no hay nada que enseñar. Una pantalla de carga aquí sería un parpadeo encima del
  // mundo por un componente que todavía no tiene nada que decir.
  return (
    <Suspense fallback={null}>
      <PasosDelMundo />
      <Caceria />
      <Minijuego />
      <JuegoDelArbol />
    </Suspense>
  );
}
